export default {"src":"/_next/static/media/polls-image.813ada71.svg","height":431,"width":351,"blurWidth":0,"blurHeight":0};